/**
 * Demo Environment Configuration
 *
 * Used for the standalone demo build — all backend HTTP traffic is intercepted
 * and served from in-memory demo data (see src/app/core/demo/). No real backend
 * is required or contacted; apiUrl below points at a loopback port nothing
 * listens on, so any request the interceptor doesn't cover fails fast
 * (ECONNREFUSED) instead of hanging on DNS resolution for a fake hostname.
 */

import { Environment, baseEnvironment } from './environment.base';

export const environment: Environment = {
  ...baseEnvironment as Environment,
  production: false,
  environmentName: 'demo',
  apiUrl: 'http://127.0.0.1:59999',
  demo: true,
  enableDebugTools: true,
  enableAnalytics: false,
  enableServiceWorker: false,
  features: {
    ...baseEnvironment.features!,
    enableChatbot: false,
    enableOfflineMode: false
  },
  logging: {
    enableConsoleLogging: true,
    enableErrorTracking: false
  },
  auth: {
    ...baseEnvironment.auth!,
    enableGuards: true // Guards behave normally; the fabricated JWT satisfies them
  }
};
